<div class="comments-card">
  <div class="comments-card__header" ubi-curve-header xlarge>
    <div class="comments-card__header-text">
     {{ 'comments.header' | translate }}
    </div>
    <div class="comments-card__header-sub-text" *ngIf="subHeaderName">
      {{subHeaderName}}
    </div>
  </div>
  <div class="comments-card__content">
    <artemis-loading-spinner *ngIf="loading"></artemis-loading-spinner>
    <div class="functional-header">
      <div class="functional-header__add-comment-btn" (click)="openAddCommentForm()">
        <img class="functional-header__add-comment-btn-icon" src="/assets/icons/add-icon-secondary-font-color.png">
        <span class="functional-header__add-comment-btn-label"> {{ 'comments.label.add_a_comment' | translate }} </span>
      </div>
    </div>
    <div class="comment__list">
      <ng-container *ngIf="(commentList && commentList.length > 0); else noComment;">
        <div class="comment" *ngFor="let comment of commentList">
          <div class="comment__writer uppercase-text">{{comment.createdBy?.name}}</div>
          <div class="comment__time">{{comment.createdAt | date:'dd/MM/yyyy \'at\' h:mm:ss a'}}</div>
          <div class="comment__content">{{comment.content}}</div>
          <button class="btn comment__delete-btn" (click)="emitDeleteComment(comment.id)" *ngIf="allowDeleteComment" title="Delete">
            <img class="themified-white-icon comment__delete-btn-icon" src="/assets/icons/minus-icon-white.png">
          </button>
        </div>
      </ng-container>
      <ng-template #noComment>
        <div class="comment">
          <div class="comment__content"> {{ 'comments.message' | translate }}</div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<ng-template #addCommentForm>
  <div class="add-comment-container">
    <div class="add-comment__header">
      <div class="add-comment__header-text">
        <img class="add-comment__icon" src="/assets/icons/add-icon-secondary-font-color.png">
        <span class="add-comment__label"> {{ 'comments.label.add_a_comment' | translate }} </span>
      </div>
      <div class="add-comment__close">
        <img class="themified-white-icon add-comment__close-icon" src="/assets/icons/cross-icon.png" (click)="closeAddCommentModal()" />
      </div>
    </div>
    <div class="add-comment__content">
      <div class="add-comment__name uppercase-text">{{(currentUser$ | async).name}}</div>
      <div class="add-comment__comment">
        <mat-form-field appearance="fill" class="custom-mat-form-field add-comment__form-field">
          <mat-label> {{ 'comments.label.comment' | translate }} </mat-label>
          <textarea matInput rows="10" [(ngModel)]="commentContent"></textarea>
        </mat-form-field>
      </div>
      <div class="add-comment__action">
        <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded" (click)="emitSubmitComment()"
          [disabled]="commentContent === ''">
           {{ 'comments.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
